const getters = {
  list: state => state.list,
  bidsList: state => state.bidsList,
  firstInTransporterList: state => state.firstInTransporterList,
  isLoading: state => state.isLoading,
  isUploading: state => state.isUploading,
  isPaginating: state => state.isPaginating,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
  parentList: state => state.parentList,
  canShowSaveGRN: state => state.canShowSaveGRN,
  userEdited: state => state.userEdited,
  warnedOnce: state => state.warnedOnce,
  returnMaterialDetails: state => state.returnMaterialDetails,
  returnMaterialsWarnedOnce: state => state.returnMaterialsWarnedOnce,
  hasUserEdited: state => state.userEdited,
  indentRepublishRequests: state => state.indentRepublishRequests,
};
export default getters;
